import { API_PDC_URL_V2, API_PDC_URL_V1 } from "../../../config";
import { logout } from "../auth";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { callWithRetry } from "../../services/callWithRetry";

export const companyConstants = {
  CLEAR_SEARCHED_COMPANY: "CLEAR_SEARCHED_COMPANY",
  LOAD_COMPANY_START: "LOAD_COMPANY_START",
  LOAD_COMPANY_SUCCESS: "LOAD_COMPANY_SUCCESS",
  LOAD_SEARCHED_COMPANY_SUCCESS: "LOAD_SEARCHED_COMPANY_SUCCESS",
  LOAD_COMPANY_ERROR: "LOAD_COMPANY_ERROR",

  LOAD_STUDIO_COMPANIES_START: "LOAD_STUDIO_COMPANIES_START",
  LOAD_STUDIO_COMPANIES_SUCCESS: "LOAD_STUDIO_COMPANIES_SUCCESS",
  LOAD_STUDIO_COMPANIES_ERROR: "LOAD_STUDIO_COMPANIES_ERROR",

  GET_USERS_START: "GET_USERS_START",
  GET_USERS_SUCCESS: "GET_USERS_SUCCESS",
  GET_USERS_ERROR: "GET_USERS_ERROR"
};

export function clearSearched() {
  return (dispatch) => {
    dispatch({
      type: companyConstants.CLEAR_SEARCHED_COMPANY
    });
  };
}
export function loadCompany(
  searchTerm = "", page = 0, size = 40, companiesList = null
) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const accountantID = getState().main.accountantIdSelected;
    const myType = getState().main.myType;

    return new Promise((resolve, reject) => {
      let isAppend = page > 0;

      if (searchTerm === "" && !isAppend)
        dispatch({
          type: companyConstants.LOAD_COMPANY_START
        });

      const accountantGetParam = myType === "STUDIO" && accountantID ? `&accountantId=${accountantID}` : "";
      let request = {
        method: "get",
        url: `${API_PDC_URL_V2}/anagrafica/companies?fullText=${searchTerm}&page=${page}&size=${size}${accountantGetParam}`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      return callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            // se non ho risultati ma ho fatto ricerca allora non caricare nulla
            if (searchTerm !== "") {
              dispatch({
                type: companyConstants.LOAD_SEARCHED_COMPANY_SUCCESS,
                payload: { data: result.data, companiesList: companiesList }
              });
              resolve(result.data);
            } else {
              dispatch({
                type: companyConstants.LOAD_COMPANY_SUCCESS,
                payload: {
                  result: result.data.items.filter((el) => {
                    return el.classifier !== "STUDIO";
                  }),
                  hasMoreItems: result.data.hasMoreItems,
                  isAppend: isAppend
                }
              });
              resolve(result.data.items.filter((el) => {
                return el.classifier !== "STUDIO";
              }));
            }
          } else {
            dispatch({
              type: companyConstants.LOAD_COMPANY_ERROR,
              payload: result
            });
            reject();
          }
        })
        .catch((response) => {
          if (response.message === "Network Error" || response.message === "Request failed with status code 403") {
            logout();
          }
          dispatch({
            type: companyConstants.LOAD_COMPANY_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getUsersList(withLogin = false) {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const itemId = getState().main.companyUuidSelected;
    const managerId = getState().main.accountantUuidSelected;
    return new Promise((resolve, reject) => {
      dispatch({
        type: companyConstants.GET_USERS_START
      });

      let request = {
        method: "get",
        url: API_PDC_URL_V1 + "/users?" + "&itemId=" + itemId + "&managerId=" + managerId + "&withLogin=" + withLogin,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: companyConstants.GET_USERS_SUCCESS,
              payload: {
                itemUsers: result.data._embedded.itemUsers,
                managerUsers: result.data._embedded.managerUsers
              }
            });
            resolve(result);
          } else {
            dispatch({
              type: companyConstants.GET_USERS_ERROR,
              payload: result
            });
            reject();
          }
        })
        .catch((response) => {
          if (response.message === "Network Error" || response.message === "Request failed with status code 403") {
            reject();
          }
          dispatch({
            type: companyConstants.GET_USERS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
